import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api, STATUS, money } from "@/lib/api";
import { PageHero, StatusPill, Bar, Empty } from "@/components/Shared";
import PondMap from "@/components/PondMap";

export default function MapPage() {
  const { data = [], isLoading } = useQuery({ queryKey: ["projects"], queryFn: () => api.get("/projects").then((r) => r.data) });
  const [filter, setFilter] = useState("all");
  const [q, setQ] = useState("");
  const list = data.filter((p) => (filter === "all" || p.status === filter) && (!q || `${p.code} ${p.name} ${p.zip} ${p.neighborhood}`.toLowerCase().includes(q.toLowerCase())));
  return (
    <div data-testid="map-page">
      <PageHero eyebrow="Pond Safety Map • Projects" title="One pond at a time." sub="Click a pin to open the complete project. Status reflects program progress — not a legal safety determination." />
      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-10">
        <div className="flex flex-wrap gap-2 items-center">
          <button onClick={() => setFilter("all")} data-testid="map-filter-all" className={`rounded-full px-4 py-2 text-xs font-bold uppercase ${filter === "all" ? "bg-[#03045E] text-white" : "bg-white border border-sky-200"}`}>All ({data.length})</button>
          {Object.entries(STATUS).map(([k, s]) => (
            <button key={k} onClick={() => setFilter(k)} data-testid={`map-filter-${k}`} className={`rounded-full px-4 py-2 text-xs font-bold uppercase flex items-center gap-2 border ${filter === k ? "text-white" : "bg-white"}`} style={filter === k ? { background: s.color, borderColor: s.color } : { borderColor: s.color }}>
              <span className="w-2.5 h-2.5 rounded-full" style={{ background: filter === k ? "#fff" : s.color }} />{s.label} ({data.filter((p) => p.status === k).length})
            </button>
          ))}
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search code, ZIP, neighborhood" data-testid="map-search-input" className="ml-auto rounded-full border border-sky-200 px-4 py-2 text-sm w-full sm:w-64" />
        </div>
        <div className="mt-6"><PondMap projects={list} height={520} /></div>
        <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {!isLoading && list.length === 0 && <div className="md:col-span-3"><Empty testid="projects-empty">No projects match yet. <Link to="/report" className="font-bold text-[#0077B6]">Report a pond for review →</Link></Empty></div>}
          {list.map((p) => (
            <Link key={p.code} to={`/projects/${p.code}`} className="rounded-2xl bg-white border border-sky-100 p-5 card-lift" data-testid={`project-card-${p.code}`}>
              <div className="flex justify-between items-start gap-2"><p className="font-display text-xl text-[#03045E]">{p.code}</p><StatusPill status={p.status} /></div>
              <p className="font-semibold mt-1">{p.name}</p>
              <p className="text-sm text-slate-500">{[p.neighborhood, p.city, p.state, p.zip].filter(Boolean).join(", ")}</p>
              {p.goal_total > 0 && <div className="mt-4"><Bar value={p.raised_total} max={p.goal_total} /><p className="text-xs mt-1 text-slate-600">{money(p.raised_total)} of {money(p.goal_total)}</p></div>}
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
